function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_Mail",
  "data-name": "Icon Mail",
  transform: "translate(33.642 21.56) rotate(135)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_175",
  "data-name": "Pfad 175",
  d: "M20.465,14.43,6.035,0-4.557,10.592l14.43,14.43Z",
  transform: "translate(0.589 0)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_105",
  "data-name": "Linie 105",
  x2: 10.187,
  transform: "translate(10.576 14.41)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_106",
  "data-name": "Linie 106",
  y1: 10.213,
  transform: "translate(6.487 0.108)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_96",
  "data-name": "Linie 96",
  y1: 0.017,
  x2: 14.268,
  transform: "translate(-3.709 10.312)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_97",
  "data-name": "Linie 97",
  x1: 0.009,
  y1: 14.294,
  transform: "translate(10.56 10.312)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.508,
    height: 37.508,
    viewBox: "0 0 37.508 37.508",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.28c02e0c.svg";
export { ForwardRef as ReactComponent };